import WarningMessage from "components/atomics/WarningMessage";
import React from "react";
import translations from "translations";

export const MandatoryFieldMessage = () => {
  return <WarningMessage text={translations.globals.validationMessages.validation} />;
};
export default MandatoryFieldMessage;
